import { render, staticRenderFns } from "./informativaLogin.vue?vue&type=template&id=519e0fb4&scoped=true"
import script from "./informativaLogin.vue?vue&type=script&lang=js"
export * from "./informativaLogin.vue?vue&type=script&lang=js"
import style0 from "./informativaLogin.vue?vue&type=style&index=0&id=519e0fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e0fb4",
  null
  
)

export default component.exports